/* 保証登録 / 保証申請フォーム（sections/dd-warranty-form.liquid）
   送信先: Google Apps Script ウェブアプリ（JSONをtext/plainで送るため事前確認リクエストは発生しない） */
(() => {
  const OFFICIAL = '公式オンラインストア';
  const MAX_ITEMS = 5;
  const MAX_EDGE = 1600; // 写真の長辺（px）
  const LABELS = {
    purchase_place: '購入場所', order_no: '注文番号', shop_name: '販売店名', receipt_no: 'レシート番号', purchase_date: '購入日',
    product: '製品名', symptom: '不具合の種類', detail: '状況の説明', photos: '写真', name: 'お名前', email: 'メールアドレス',
    phone: '電話番号', zip: '郵便番号', address: '住所', consent: 'プライバシーポリシーへの同意',
  };

  document.querySelectorAll('.dwf-form').forEach((form) => {
    const type = form.dataset.type;
    const endpoint = form.dataset.endpoint;
    const started = Date.now();
    const section = form.closest('.dwf');
    const errorBox = form.querySelector('.dwf-error');
    const itemsBox = form.querySelector('[data-items]');
    const template = itemsBox.querySelector('[data-item]').cloneNode(true);
    const today = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 10);
    form.querySelectorAll('input[type=date]').forEach((el) => { el.max = today; });
    const src = new URLSearchParams(location.search).get('src');
    if (src) form.elements.source.value = src.slice(0, 40);

    // 購入場所で入力欄を切り替える
    const regInput = form.elements.registration_id;
    const syncPurchase = () => {
      const place = (form.querySelector('input[name=purchase_place]:checked') || {}).value || '';
      form.querySelectorAll('[data-when]').forEach((el) => {
        el.hidden = !place || (el.dataset.when === 'official') !== (place === OFFICIAL);
      });
      const needPurchase = !(regInput && regInput.value.trim());
      form.querySelectorAll('[data-req-purchase]').forEach((el) => { el.textContent = needPurchase ? '必須' : '登録番号があれば不要'; });
    };
    form.addEventListener('change', (e) => { if (e.target.name === 'purchase_place') syncPurchase(); });
    if (regInput) regInput.addEventListener('input', syncPurchase);
    syncPurchase();

    // 製品の行（一覧にない製品は直接入力、最大5点）
    const bindItem = (row) => {
      const sel = row.querySelector('[data-product]');
      const other = row.querySelector('[data-product-other]');
      sel.addEventListener('change', () => { other.hidden = sel.value !== '__other'; if (!other.hidden) other.focus(); });
      const rm = row.querySelector('[data-remove]');
      if (rm) rm.addEventListener('click', () => { row.remove(); syncItems(); });
    };
    const syncItems = () => {
      const rows = itemsBox.querySelectorAll('[data-item]');
      rows.forEach((r) => { const rm = r.querySelector('[data-remove]'); if (rm) rm.hidden = rows.length === 1; });
      const add = form.querySelector('[data-add]');
      if (add) add.hidden = rows.length >= MAX_ITEMS;
    };
    itemsBox.querySelectorAll('[data-item]').forEach(bindItem);
    const addBtn = form.querySelector('[data-add]');
    if (addBtn) addBtn.addEventListener('click', () => {
      const row = template.cloneNode(true);
      itemsBox.appendChild(row); bindItem(row); syncItems();
      row.querySelector('[data-product]').focus();
    });
    syncItems();

    // 写真のプレビュー
    const photoInput = form.querySelector('[data-files][data-required]');
    const previews = form.querySelector('[data-previews]');
    if (photoInput && previews) photoInput.addEventListener('change', () => {
      previews.innerHTML = '';
      [...photoInput.files].slice(0, Number(photoInput.dataset.files)).forEach((f) => {
        const li = document.createElement('li'); const img = document.createElement('img');
        img.alt = ''; img.src = URL.createObjectURL(f); li.appendChild(img); previews.appendChild(li);
      });
    });

    const resize = (file) => new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        const scale = Math.min(1, MAX_EDGE / Math.max(img.naturalWidth, img.naturalHeight));
        const c = document.createElement('canvas');
        c.width = Math.round(img.naturalWidth * scale); c.height = Math.round(img.naturalHeight * scale);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(img.src);
        resolve(c.toDataURL('image/jpeg', 0.82));
      };
      img.onerror = () => reject(new Error('image'));
      img.src = URL.createObjectURL(file);
    });

    const showError = (msg) => {
      errorBox.innerHTML = msg; errorBox.hidden = false;
      errorBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      errorBox.hidden = true;
      form.querySelectorAll('[aria-invalid]').forEach((el) => el.removeAttribute('aria-invalid'));
      const v = (name) => { const el = form.elements[name]; return el ? String(el.value || '').trim() : ''; };
      const place = (form.querySelector('input[name=purchase_place]:checked') || {}).value || '';
      const data = {
        form_type: type, website: v('website'), source: v('source'), elapsed_ms: Date.now() - started,
        registration_id: v('registration_id').toUpperCase(), purchase_place: place,
        order_no: place === OFFICIAL ? v('order_no') : '', shop_name: place && place !== OFFICIAL ? v('shop_name') : '',
        receipt_no: place && place !== OFFICIAL ? v('receipt_no') : '', purchase_date: v('purchase_date'),
        symptom: v('symptom'), noticed_date: v('noticed_date'), usage: v('usage'), detail: v('detail'),
        request: (form.querySelector('input[name=request]:checked') || {}).value || '',
        name: v('name'), name_kana: v('name_kana'), email: v('email'), phone: v('phone'), zip: v('zip'), address: v('address'),
        consent: form.elements.consent.checked ? '同意する' : '',
      };
      const items = [...itemsBox.querySelectorAll('[data-item]')].map((row) => {
        const sel = row.querySelector('[data-product]');
        const product = sel.value === '__other' ? row.querySelector('[data-product-other]').value.trim() : sel.value;
        const qty = row.querySelector('[data-qty]');
        return { product, variant: row.querySelector('[data-variant]').value.trim(), qty: qty ? qty.value : '1', row };
      });

      // 入力チェック
      const missing = [];
      const need = (key, el) => { if (!data[key]) { missing.push(key); if (el) el.setAttribute('aria-invalid', 'true'); } };
      const needPurchase = type === 'registration' || !data.registration_id;
      if (needPurchase) {
        need('purchase_place', form.querySelector('input[name=purchase_place]'));
        need('purchase_date', form.elements.purchase_date);
        if (place === OFFICIAL) need('order_no', form.elements.order_no);
        if (place && place !== OFFICIAL) { need('shop_name', form.elements.shop_name); if (type === 'registration') need('receipt_no', form.elements.receipt_no); }
      }
      if (!items.some((it) => it.product)) { missing.push('product'); items[0].row.querySelector('[data-product]').setAttribute('aria-invalid', 'true'); }
      if (type === 'claim') { need('symptom', form.elements.symptom); need('detail', form.elements.detail); need('zip', form.elements.zip); need('address', form.elements.address); }
      ['name', 'email', 'phone'].forEach((k) => need(k, form.elements[k]));
      if (!data.consent) missing.push('consent');
      const photoFiles = photoInput ? [...photoInput.files] : [];
      if (photoInput && !photoFiles.length) { missing.push('photos'); photoInput.setAttribute('aria-invalid', 'true'); }
      if (missing.length) return showError('<strong>次の項目をご入力ください。</strong><br>' + [...new Set(missing)].map((k) => LABELS[k] || k).join('、'));
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) { form.elements.email.setAttribute('aria-invalid', 'true'); return showError('メールアドレスの形式をご確認ください。'); }

      const btn = form.querySelector('[type=submit]');
      btn.disabled = true; const label = btn.textContent; btn.textContent = '送信しています…';
      try {
        const fileInputs = [...form.querySelectorAll('[data-files]')];
        const files = [];
        for (const input of fileInputs) {
          for (const f of [...input.files].slice(0, Number(input.dataset.files))) files.push({ data: await resize(f) });
        }
        const payload = Object.assign({}, data, { files });
        if (type === 'registration') payload.items = items.filter((it) => it.product).map(({ product, variant, qty }) => ({ product, variant, qty }));
        else { payload.product = items[0].product; payload.variant = items[0].variant; }
        const res = await fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify(payload) });
        const out = await res.json();
        if (!out.ok) throw new Error(out.error || 'server');
        form.hidden = true;
        const done = section.querySelector('.dwf-done');
        done.querySelector('[data-receipt]').textContent = out.receipt_id || '';
        if (out.mailed === false) { const m = done.querySelector('[data-mail-note]'); if (m) m.textContent = '受付メールを送信できませんでした。この画面の番号を控えてください。'; }
        done.hidden = false; done.focus(); done.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (err) {
        btn.disabled = false; btn.textContent = label;
        showError(err.message === 'image'
          ? '写真を読み込めませんでした。JPEGまたはPNG形式の写真をお選びください。'
          : '送信できませんでした。時間をおいて再度お試しいただくか、<a href="/pages/contact">お問い合わせフォーム</a>からご連絡ください。');
      }
    });
  });
})();
